import { WEB_PUSH_NOTIFICATION_CLICKED } from 'constants/events';
import * as analytics from 'utilities/analytics';

let paramsObj;

const parseAndStoreParams = () => {
  if (paramsObj) {
    return;
  }

  paramsObj = Object.fromEntries(new URLSearchParams(location.search));

  const dataBase64 = paramsObj?.data;
  const data = dataBase64 ? JSON.parse(atob(dataBase64)) : {};

  if (dataBase64) {
    analytics.track(WEB_PUSH_NOTIFICATION_CLICKED, {
      notificationType: data?.event,
      url: data.url,
    });
  }

  paramsObj = {
    ...paramsObj,
    ...data,
  };
};

export const getPageLoadParam = key => {
  if (!paramsObj) {
    parseAndStoreParams();
  }

  const paramVal = paramsObj[key];

  return paramVal ? String(paramVal) : '';
};

// Store page load params for use later
// We do this here in case they are cleared out early
// in other palces
parseAndStoreParams();
